class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    const summary = this.mainDetailsToggle.querySelector('summary');
    const parentUrl = this.getAttribute('data-parent-url');

    // Make summary clickable as link
    if (summary && parentUrl) {
      summary.style.cursor = 'pointer';
      summary.addEventListener('click', (e) => {
        // If shift/ctrl/cmd click, open in new tab/window
        if (e.ctrlKey || e.metaKey || e.shiftKey) {
          window.open(parentUrl, e.metaKey && !e.ctrlKey ? '_blank' : undefined);
          e.preventDefault();
        } else {
          // Regular click navigates to parent URL
          window.location.href = parentUrl;
        }
      });
    }

    // Auto-expand on hover (desktop only)
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.addEventListener('mouseenter', () => {
        this.mainDetailsToggle.open = true;
      });
      this.addEventListener('mouseleave', () => {
        this.mainDetailsToggle.open = false;
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
